export default "__VITE_ASSET__BnJASwDp__"